<template>
    <div>
        <TitleBar>
            <template v-slot:title>
              <span v-translate></span>
              <!-- <GekkoButton icon="fa fa-question-circle" variant="link" class="text-blue" v-b-tooltip.click="$gettext('The VAT report helper will guide you through filling out a standard dutch tax returns form for your quarterly VAT report. The report for each quarter is based on the data you already entered through using Gekko to send your invoices and track your costs.')" /> -->
            </template>

            <!-- <template v-slot:subtitle>
              <div style="color: #37A0CD">
                <translate>Calculated on:</translate>&nbsp;
                <span v-if="report.modified != null">{{ report.modified | formatDate }}</span>
              </div>
            </template> -->

            <template v-slot:buttons>

                <GekkoButton :text="$gettext('New Report')" type="button" @click="generateNewReport()" />
                
                <GekkoButton :text="$gettext('All VAT reports')" type="button" :to="{ name: 'TaxreportList' }" />
                

            </template>
        </TitleBar>
        
        <ReportsVATNewModal
            v-if="showNewReportModal"
            @close="onNewReportModalClose"
            :financialYears="financialYears"
        />


        <!-- :financialYears="financialYears"
            :year="year"
            :quarter="quarter"
            :month="month"
            :consolidated="consolidated" -->

        <div class="content">

            <table>
                <tbody>
                    <tr>
                        <th class="col-header" v-translate>Country</th>
                        <th class="col-header" v-translate>VAT %</th>
                        <th class="col-header" v-translate>Total Net Revenue</th>
                        <th class="col-header" v-translate>Total VAT</th>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
// import SurveyModal from "@/components/ui/SurveyModal";
// import settingsPageSetup from "@/mixins/settingsPageSetup";
import GekkoButton from "@/components/GekkoButton";
import ReportsService from "@/store/services/reports.service";
import TitleBar from "@/components/TitleBar";
import ReportsVATNewModal from "@/components/ReportsVATNewModal";
import CompanyService from "@/store/services/company.service";

export default {
    name: "ForeignTaxReport",
    components: { TitleBar, GekkoButton, ReportsVATNewModal },
    data() {
        return {
            showNewReportModal: false,

            consolidated: false,
            financialYears: [],
            year: null,
            quarter: null,
            month: null
        }
    },
    computed: {
        ...mapGetters({
          reportInitialValues: "taxreports/getReportInitialValues",
          currentCompany: "main/getCurrentCompany",
        })
    },
    created() {
        CompanyService.financiallyActiveYears(this.companyProfileId).then((response) => {
            this.financialYears = response.data.map((year) => { return { text: "year " + year, value: year} });
        });
    },
    methods: {
        generateNewReport() {
            

            this.showNewReportModal = true
        },
        onNewReportModalClose(data) {
            ReportsService.createForeignReport(data).then((response) => {
                console.log("response", response);
            });


            this.showNewReportModal = false
        }
    }
}
</script>
<style lang="scss" scoped>
table{
  width: 100%;
}
</style>